import { defineMessages } from 'react-intl';

export default defineMessages({
  recipientNameLabel: {
    id: 'gift.purchaseForm.recipientNameLabel',
    defaultMessage: 'Recipient Name',
    description: 'Label for gift card purchase recipient name field',
  },
  recipientEmailLabel: {
    id: 'gift.purchaseForm.recipientEmailLabel',
    defaultMessage: 'Recipient Email',
    description: 'Label for gift card purchase recipient email field',
  },
  senderNameLabel: {
    id: 'gift.purchaseForm.senderNameLabel',
    defaultMessage: 'Sender Name',
    description: 'Label for gift card purchase sender name field',
  },
  senderEmailLabel: {
    id: 'gift.purchaseForm.senderEmailLabel',
    defaultMessage: 'Sender Email',
    description: 'Label for gift card purchase sender email field',
  },
  messageLabel: {
    id: 'gift.purchaseForm.messageLabel',
    defaultMessage: 'Message (optional)',
    description: 'Label for gift card purchase message field',
  },
  checkoutFrap: {
    id: 'gift.purchaseForm.checkoutFrap',
    defaultMessage:
      'Checkout{amount, plural, =0 {} other { {amount, number, money}}}',
    description: 'Label for gift card purchase checkout button',
  },
  amountLabel: {
    id: 'gift.purchaseForm.amountLabel',
    defaultMessage: 'Select gift amount',
    description: 'Label for gift card purchase amount field',
  },
  customAmountOption: {
    id: 'gift.purchaseForm.customAmountOption',
    defaultMessage: 'Custom Amount',
    description:
      "Option that lets the user pick a custom amount for the card they're about to purchase",
  },
  recipientNameError: {
    id: 'gift.purchaseForm.recipientNameError',
    defaultMessage: "Please enter the recipient's name.",
    description: "Error message displayed when the recipient's name is missing",
  },
  recipientEmailMissing: {
    id: 'gift.purchaseForm.recipientEmailError',
    defaultMessage: "Please enter the recipient's email.",
    description:
      "Error message displayed when the recipient's email is missing",
  },
  senderEmailMissing: {
    id: 'gift.purchaseForm.senderEmailError',
    defaultMessage: "Please enter the sender's email.",
    description: "Error message displayed when the senders's email is missing",
  },
  senderNameError: {
    id: 'gift.purchaseForm.senderNameError',
    defaultMessage: "Please enter the sender's name.",
    description: "Error message displayed when the senders's name is missing",
  },
  emailError: {
    id: 'gift.purchaseForm.emailAddressErrorInvalid',
    defaultMessage: 'Please enter a valid email address.',
    description: 'Error message displayed when email address is invalid',
  },
  amountSelectError: {
    id: 'gift.purchaseForm.amountSelectError',
    defaultMessage: 'Please select the gift amount.',
    description: 'Error message displayed when the gift amount is missing',
  },
  giftAmountSectionHeader: {
    id: 'gift.purchaseForm.giftAmountSectionHeader',
    defaultMessage:
      'Gift amount{numberOfRecipients, plural, one {} other { for all}}',
    description: 'Header for the gift amount section',
  },
  recipientInfoSectionHeader: {
    id: 'gift.purchaseForm.recipientInfoSectionHeader',
    defaultMessage: 'Who are you gifting to?',
    description: 'Header for the recipient info section',
  },
  senderInfoSectionHeader: {
    id: 'gift.purchaseForm.senderInfoSectionHeader',
    defaultMessage: 'From',
    description: 'Header for the sender info section',
  },
  messageSectionHeader: {
    id: 'gift.purchaseForm.messageSectionHeader',
    defaultMessage:
      'Personal note{numberOfRecipients, plural, one {} other { to all}}',
    description: 'Header for the gift message section',
  },
  maxRecipients: {
    id: 'gift.purchaseForm.maxRecipients',
    defaultMessage: 'Maximum of 10 recipients',
    description:
      'Text informing user how many users they will be able to add to the order',
  },
  addRecipientButton: {
    id: 'gift.purchaseForm.addRecipientButton',
    defaultMessage: 'Add another recipient',
    description: 'Button label to add additional recipients to egift order',
  },
  multiRecipientHeader: {
    id: 'gift.purchaseForm.multiRecipientHeader',
    defaultMessage: 'Recipient { number, number}',
    description:
      'Heading to number recipients after there are more than one; text is followed by a number',
  },
  deleteRecipientLabel: {
    id: 'gift.purchaseForm.deleteRecipientLabel',
    defaultMessage: 'Delete recipient { number, number}',
    description:
      'Aria-label for trash icon informing user that it deletes recipient',
  },
  senderInformationLabel: {
    id: 'gift.purchaseForm.senderInformationLabel',
    defaultMessage: 'Sender information',
    description: 'Label for sender information section group',
  },
  recipientInformationLabel: {
    id: 'gift.purchaseForm.recipientInformationLabel',
    defaultMessage:
      'Recipient {numberOfRecipients, plural, one {} other {{ recipientNumber, number}}} information',
    description: 'Label for recipient information section group',
  },
});
